import {AbstractService} from 'services/AbstractService';

const PLACEMENT_DETAIL_URL = '/api/placements/{0}';
const PROJECT_PLACEMENTS_LIST_SIMPLE_URL = '/api/projects/{0}/placements/simple';
const ACCOUNT_PLACEMENTS_LIST_SIMPLE_URL = '/api/placements/simple';
const GET_PLACEMENT_TYPES_URL = '/api/repos/placementtypes';
const CONNECTION_PLACEMENTS_LIST_URL = '/api/connections/{0}/external/campaigns';
const ADD_PROJECT_PLACEMENTS_URL = '/api/placements';
const EDIT_SCHEDULE_PLACEMENTS_URL = '/api/placements/schedule';
const GET_SCHEDULE_HEATMAP_URL = '/api/placements/{0}/heatmap';

export class PlacementsService extends AbstractService {
  async getProjectPlacements (accountId, projectId, params = {}) {
    return (await this.client.get(
      PROJECT_PLACEMENTS_LIST_SIMPLE_URL.format(projectId), params, {accountId}, {}, {useBigIntParser: true}
    )).items;
  }

  async editSchedulePlacements (params) {
    return await this.client.put(
      EDIT_SCHEDULE_PLACEMENTS_URL,
      params
    );
  }

  getScheduleHeatmap (placementId, axiosParams = {}) {
    if (Object.keys(axiosParams).length) {
      return this.client.get(
        GET_SCHEDULE_HEATMAP_URL.format(placementId),
        {},
        {},
        axiosParams
      );
    }

    return this.client.get(GET_SCHEDULE_HEATMAP_URL.format(placementId));
  }

  getPlacementTypesFromRepos () {
    return this.client.get(GET_PLACEMENT_TYPES_URL);
  }

  get (accountId, placementId) {
    return this.client.get(
      PLACEMENT_DETAIL_URL.format(placementId), {}, {accountId}, {}, {useBigIntParser: true}
    );
  }

  async getAccountPlacements (accountId) {
    let _accountId = accountId;
    let _accountIds = [];
    if (Array.isArray(_accountId)) {
      _accountIds = accountId;
      _accountId = null;
    }

    return (await this.client.get(ACCOUNT_PLACEMENTS_LIST_SIMPLE_URL, {
      account_id: _accountIds
    }, {accountId: _accountId}, {}, {useBigIntParser: true})).items;
  }

  getConnectionPlacements (connectionId, accountId) {
    return this.client.get(
      CONNECTION_PLACEMENTS_LIST_URL.format(connectionId), {}, {accountId}, {}, {useBigIntParser: true}
    );
  }

  async addPlacements ({accountId, projectId, connectionId, placementsList,
    startTagging = false, autolabelWithCampaignsNames = false,
    utmsFromAd = true
  }) {
    return this.client.post(
      ADD_PROJECT_PLACEMENTS_URL,
      {
        account_id: accountId,
        project_id: projectId,
        connection_id: connectionId,
        placements: placementsList
      },
      {
        accountId,
        getParams: {
          start_tagging: startTagging,
          autolabel_with_campaigns_names: autolabelWithCampaignsNames,
          utms_from_ad: utmsFromAd
        }
      }
    );
  }
}
